import { render } from "./hero.vue?vue&type=template&id=3b10eda9&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=3b10eda9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b10eda9"

export default script